import type { FilterValue } from "@shopify/hydrogen-react/storefront-api-types";
import React from "react";
import { useSearchParams } from "react-router-dom";

import Input from "@atoms/Input";

interface IProps {
  filterList: FilterValue[];
  selected: string[];
  onChangeFilter: (option: FilterValue, key: string) => void;
  filterKey: string;
}

export default function FilterCard({ filterList, selected, onChangeFilter, filterKey }: IProps) {
  const [, setSearchParams] = useSearchParams();

  const options = filterList.filter((option) => option.count);

  return (
    <div className="flex flex-col gap-2.5 leading-none">
      <span className="capitalize">{filterKey}</span>
      <div className="flex flex-col gap-2">
        <Input
          checked={selected.length === 0}
          id={`All ${filterKey}`}
          label={`All ${filterKey}`}
          name={filterKey}
          onChange={() => {
            setSearchParams((prev) => {
              const next = new URLSearchParams(prev);
              next.delete(filterKey);
              return next;
            });
          }}
          type="checkbox"
          value={`All ${filterKey}`}
        />

        {options.length ? (
          <>
            {options.map((option) => (
              <Input
                checked={selected.includes(option.label)}
                id={option.label}
                key={option.label}
                label={option.label}
                name={filterKey}
                onChange={() => {
                  onChangeFilter(option, filterKey);
                }}
                type="checkbox"
                value={option.label}
              />
            ))}
          </>
        ) : null}
      </div>
    </div>
  );
}
